<template>
    <div class="container">
        <div class="line-input">
            <textarea
                :value="text"
                @input="handleInput"
                class="text"
                rows="1"
                @focus="$emit('focus')"
                @blur="$emit('blur')"
                @keydown="$emit('keydown', $event)"
                ref="inputElement"
            ></textarea>
            <FourWayToggle 
                :modelValue="selectedOption"
                @update:modelValue="$emit('update:selectedOption', $event)"
            />
        </div>
    </div>
</template>

<script>
import FourWayToggle from './FourWayToggle.vue';

export default {
    components: {
        FourWayToggle
    },
    props: {
        text: String,
        selectedOption: String
    },
    emits: ['update:text', 'update:selectedOption', 'focus', 'blur', 'keydown'],
    data() {
        return {
            options: [
                { label: 'C', value: 'c' },
                { label: 'I', value: 'i' },
                { label: 'R', value: 'r' },
                { label: 'Q', value: 'q' }
            ]
        };
    },
    methods: {
        handleInput(event) {
            const textarea = event.target;
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';

            this.$emit('update:text', event.target.value);

            if (event.target.value && this.selectedOption === null) {
                this.$emit('update:selectedOption', 'c');
            }
        },
        async submitForm() {
            this.notificationMessage = 'Saving...';
            this.notificationVisible = true;

            // Set timestamps
            if (this.jsonData.timeCreated === '') {
                this.jsonData.timeCreated = new Date().toUTCString();
            }
            this.jsonData.timeLastModified = new Date().toUTCString();

            // Get notes from NotesSection component
            const notesSection = this.$refs.notesSection;
            const administeringNotes = notesSection.getAdministeringNotes();
            const scoringNotes = notesSection.getScoringNotes();

            if (this.jsonData) {
                if (this.isAdministering) {
                    this.jsonData.administeringNotes = administeringNotes || '';
                } else {
                    this.jsonData.scoringNotes = scoringNotes || '';
                }
            }

            try {
                await this.controller.submitForm(this.jsonData);
                this.notificationMessage = 'Saved successfully!';
                this.hasUnsavedChanges = false;
            } catch (error) {
                this.notificationMessage = 'Error saving data';
                console.error('Save error', error);
            } finally {
                this.resetNotification();
            }
        },
        focus() {
            this.$refs.inputElement.focus();
        }
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    padding: 10px 10px 10px 5px;
    box-sizing: border-box;
}

.line-input {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 8px 8px 0;
    margin-bottom: 10px;
    cursor: text;
}

.text {
    flex: 1;
    font-family: inherit;
    font-size: 16px;
    padding: 10px;
    border: 1px solid gray;
    background: transparent;
    outline: none;
    box-shadow: none;
    box-sizing: border-box;
    width: 100%;
    margin-right: 10px;
    resize: none;
    overflow: hidden;
}
</style>
